import { TypographyH3 } from '@talentmesh/ui/components/typography';

export interface JobAdLabelProps {
    label: string;
}

function JobAdLabel({ label }: JobAdLabelProps) {
    return <TypographyH3 className="text-foreground font-bold">{label}</TypographyH3>;
}

export default JobAdLabel;
